"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
const flatbuffers = require("flatbuffers");
const category_js_1 = require("../../sportsbook/tree/category.js");
const sport_js_1 = require("../../sportsbook/tree/sport.js");
const tournament_js_1 = require("../../sportsbook/tree/tournament.js");
class Tree {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTree(bb, obj) {
        return (obj || new Tree()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTree(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Tree()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    sports(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new sport_js_1.Sport()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    sportsLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    categories(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new category_js_1.Category()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    categoriesLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    tournament(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new tournament_js_1.Tournament()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    tournamentLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startTree(builder) {
        builder.startObject(3);
    }
    static addSports(builder, sportsOffset) {
        builder.addFieldOffset(0, sportsOffset, 0);
    }
    static createSportsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startSportsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addCategories(builder, categoriesOffset) {
        builder.addFieldOffset(1, categoriesOffset, 0);
    }
    static createCategoriesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startCategoriesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addTournament(builder, tournamentOffset) {
        builder.addFieldOffset(2, tournamentOffset, 0);
    }
    static createTournamentVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startTournamentVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endTree(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTree(builder, sportsOffset, categoriesOffset, tournamentOffset) {
        Tree.startTree(builder);
        Tree.addSports(builder, sportsOffset);
        Tree.addCategories(builder, categoriesOffset);
        Tree.addTournament(builder, tournamentOffset);
        return Tree.endTree(builder);
    }
}
exports.Tree = Tree;
